import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { NOTICE_TYPES } from "@appcues/component-library";
import { selectSystemStatus } from "reducers/system/status";
import { getThemeFor } from "utils";

const SystemStatusNotice = ({ systemStatus }) => {
  if (!systemStatus) return null;

  return ["warn", "info"].includes(systemStatus.status) ? (
    <StyledNotice
      type={
        systemStatus.status === "info"
          ? NOTICE_TYPES.primary
          : NOTICE_TYPES.warning
      }
    >
      <div dangerouslySetInnerHTML={{ __html: systemStatus.message }} />
    </StyledNotice>
  ) : null;
};

SystemStatusNotice.propTypes = {
  systemStatus: PropTypes.shape({
    status: PropTypes.string,
    message: PropTypes.string
  })
};

const StyledNotice = styled.div`
  width: 100%;
  background: ${({ type }) =>
    type === "primary"
      ? getThemeFor("$purple-med")
      : getThemeFor("$yellow-light")};
  color: ${({ type }) =>
    type === "primary"
      ? getThemeFor("$purple")
      : getThemeFor("$yellow-xtradark")};
  padding: 20px 50px;
  font-size: 15px;
  border-bottom: 2px solid
    ${({ type }) => (type === "primary" ? "#D7D7FF" : getThemeFor("$yellow"))};
`;

function mapStateToProps(state) {
  return {
    systemStatus: selectSystemStatus(state)
  };
}

export default connect(mapStateToProps)(SystemStatusNotice);
